// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { toast } from 'sonner';

const formatRow = (f) => ({
  'Título': f.title,
  'Tipo': f.form_type === 's25b' ? 'S-25b' : 'S-45b',
  'Status': f.status === 'concluido' ? 'Concluído' : 'Em andamento',
  'Criado por': f.created_by_name || '',
  'Data Criação': new Date(f.created_at).toLocaleDateString('pt-BR'),
  'Campos Preenchidos': `${f.fields_filled || 0}/${f.total_fields || 52}`,
});

export async function exportFormsToExcel(forms, formLabel) {
  if (forms.length === 0) {
    toast.error('Nenhum relatório para exportar');
    return;
  }
  try {
    toast.loading('Gerando Excel...', { id: 'export' });
    const XLSX = (await import('xlsx')).default;
    const rows = forms.map(formatRow);
    const ws = XLSX.utils.json_to_sheet(rows);
    ws['!cols'] = [{ wch: 35 }, { wch: 10 }, { wch: 14 }, { wch: 25 }, { wch: 14 }, { wch: 18 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `Relatórios ${formLabel}`);
    XLSX.writeFile(wb, `Relatorios_${formLabel}_${new Date().toISOString().slice(0, 10)}.xlsx`);
    toast.success('Excel exportado!', { id: 'export' });
  } catch (err) {
    console.error(err);
    toast.error('Erro ao exportar Excel', { id: 'export' });
  }
}

export async function exportFormsToPdf(forms, formLabel) {
  if (forms.length === 0) {
    toast.error('Nenhum relatório para exportar');
    return;
  }
  try {
    toast.loading('Gerando PDF...', { id: 'export' });
    const { default: jsPDF } = await import('jspdf');
    await import('jspdf-autotable');
    const doc = new jsPDF({ orientation: 'landscape' });
    doc.setFontSize(16);
    doc.text(`Relatórios ${formLabel}`, 14, 18);
    doc.setFontSize(9);
    doc.setTextColor(120);
    doc.text(`Exportado em ${new Date().toLocaleDateString('pt-BR')} | Total: ${forms.length} relatório(s)`, 14, 25);
    doc.autoTable({
      startY: 30,
      head: [['Título', 'Tipo', 'Status', 'Criado por', 'Data', 'Campos']],
      body: forms.map(f => [
        f.title,
        f.form_type === 's25b' ? 'S-25b' : 'S-45b',
        f.status === 'concluido' ? 'Concluído' : 'Em andamento',
        f.created_by_name || '',
        new Date(f.created_at).toLocaleDateString('pt-BR'),
        `${f.fields_filled || 0}/${f.total_fields || 52}`,
      ]),
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { fillColor: [30, 41, 59], textColor: 255, fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [248, 250, 252] },
      columnStyles: { 0: { cellWidth: 80 }, 3: { cellWidth: 50 } },
    });
    doc.save(`Relatorios_${formLabel}_${new Date().toISOString().slice(0, 10)}.pdf`);
    toast.success('PDF exportado!', { id: 'export' });
  } catch (err) {
    console.error(err);
    toast.error('Erro ao exportar PDF', { id: 'export' });
  }
}
